import type { Api, Cruz } from '@cruz-com/lookup'
import { encodeQuery } from '@/lib'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function userSearch(params: object): Promise<Api.Result<Cruz.UserDisplay[]>> {
  try {
    const res = await fetch(`${baseURL}/cruz/users?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject({ ...d, status: res.status })
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function userDetail(params: object): Promise<Api.Result<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/cruz/user?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
      next: { revalidate: 0 },
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject({ ...d, status: res.status })
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function toggleDisableUser(id: string): Promise<Partial<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/cruz/user/toggle-disable?id=${id}`, {
      method: 'PATCH',
      headers: await getHeader(),
      next: { revalidate: 0 },
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function updatePostVehicleLimit(id: string, post_vehicle_limit: number): Promise<Partial<Cruz.User>> {
  try {
    const res = await fetch(`${baseURL}/cruz/user/post-vehicle-limit?id=${id}`, {
      method: 'PATCH',
      headers: await getHeader(),
      body: JSON.stringify({ post_vehicle_limit }),
      next: { revalidate: 0 },
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
